export const resources = {
    func: {
        eq: {
            label: '=',
            hint: 'The function returns TRUE if the value of the <code>value1</code> parameter is equal to the value of the <code>value2</code> parameter.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The first value to be tested.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The second value to be tested.'
                }
            }
        },
        ne: {
            label: '<>',
            hint: 'The function returns TRUE if the value of the <code>value1</code> parameter is not equal to the value of the <code>value2</code> parameter.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The first value to be tested.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The second value to be tested.'
                }
            }
        },
        gt: {
            label: '>',
            hint: 'The function returns TRUE if the value of the <code>value1</code> parameter is greater than the value of the <code>value2</code> parameter.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The first value to be tested.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The second value to be tested.'
                }
            }
        },
        ge: {
            label: '>=',
            hint: 'The function returns TRUE if the value of the <code>value1</code> parameter is greater than or equal to the value of the <code>value2</code> parameter.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The first value to be tested.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The second value to be tested.'
                }
            }
        },
        lt: {
            label: '<',
            hint: 'The function returns TRUE if the value of the <code>value1</code> parameter is less than the value of the <code>value2</code> parameter.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The first value to be tested.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The second value to be tested.'
                }
            }
        },
        le: {
            label: '<=',
            hint: 'The function returns TRUE if the value of the <code>value1</code> parameter is less than or equal to the value of the <code>value2</code> parameter.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The first value to be tested.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The second value to be tested.'
                }
            }
        },
        isNull: {
            label: 'Is empty',
            hint: 'The function returns TRUE if <code>value</code> is empty (NULL).',
            param: {
                value: {
                    label: 'value',
                    hint: 'The value to be tested.'
                }
            }
        },
        isNotNull: {
            label: 'Is not empty',
            hint: 'The function returns TRUE if <code>value</code> is not empty (NULL).',
            param: {
                value: {
                    label: 'value',
                    hint: 'The value to be tested.'
                }
            }
        },
        between: {
            label: 'Is between',
            hint: 'The function returns TRUE if <code>value</code> is greater than or equal to <code>min</code> and less than or equal to <code>max</code>.',
            param: {
                value: {
                    label: 'value',
                    hint: 'The value to be tested.'
                },
                min: {
                    label: 'min',
                    hint: 'Lower limit of the interval.'
                },
                max: {
                    label: 'max',
                    hint: 'Upper limit of the interval.'
                }
            }
        },
        contains: {
            label: 'Contains',
            hint: 'The function returns TRUE if the text <code>where</code> contains the text <code>what</code>.',
            param: {
                where: {
                    label: 'where',
                    hint: 'The text to search in.'
                },
                what: {
                    label: 'what',
                    hint: 'The text to search for.'
                }
            }
        },
        startsWith: {
            label: 'Starts with',
            hint: 'The function returns TRUE if the text <code>where</code> starts with the text <code>what</code>.',
            param: {
                where: {
                    label: 'where',
                    hint: 'The text to search in.'
                },
                what: {
                    label: 'what',
                    hint: 'The text to search for.'
                }
            }
        },
        endsWith: {
            label: 'Ends with',
            hint: 'The function returns TRUE if the text <code>where</code> ends with the text <code>what</code>.',
            param: {
                where: {
                    label: 'where',
                    hint: 'The text to search in.'
                },
                what: {
                    label: 'what',
                    hint: 'The text to search for.'
                }
            }
        },
        notContains: {
            label: 'Not contains',
            hint: 'The function returns TRUE if the text <code>where</code> not contains the text <code>what</code>.',
            param: {
                where: {
                    label: 'where',
                    hint: 'The text to search in.'
                },
                what: {
                    label: 'what',
                    hint: 'The text to search for.'
                }
            }
        },
        notStartsWith: {
            label: 'Not starts with',
            hint: 'The function returns TRUE if the text <code>where</code> not starts with the text <code>what</code>.',
            param: {
                where: {
                    label: 'where',
                    hint: 'The text to search in.'
                },
                what: {
                    label: 'what',
                    hint: 'The text to search for.'
                }
            }
        },
        notEndsWith: {
            label: 'Not ends with',
            hint: 'The function returns TRUE if the text <code>where</code> not ends with the text <code>what</code>.',
            param: {
                where: {
                    label: 'where',
                    hint: 'The text to search in.'
                },
                what: {
                    label: 'what',
                    hint: 'The text to search for.'
                }
            }
        },
        add: {
            label: '+',
            hint: 'The function returns the sum of <code>value1</code> and <code>value2</code>.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The first addend.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The second addend.'
                }
            }
        },
        sub: {
            label: '-',
            hint: 'The function returns the difference between <code>value1</code> and <code>value2</code>.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The minuend.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The subtrahend.'
                }
            }
        },
        mul: {
            label: '*',
            hint: 'The function returns the product of <code>value1</code> and <code>value2</code>.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The multiplier.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The multiplicand.'
                }
            }
        },
        div: {
            label: '/',
            hint: 'The function returns the quotient of <code>value1</code> and <code>value2</code>.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The dividend.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The divisor.'
                }
            }
        },
        mod: {
            label: '%',
            hint: 'The function returns the remainder after dividing <code>value1</code> by <code>value2</code>.',
            param: {
                value1: {
                    label: 'value1',
                    hint: 'The dividend.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The divisor.'
                }
            }
        },
        concat: {
            label: 'Concat',
            hint: 'The function returns the text formed by joining <code>text1</code> and <code>text2</code>.',
            param: {
                text1: {
                    label: 'text1',
                    hint: 'The first joined text.'
                },
                text2: {
                    label: 'text2',
                    hint: 'The second joined text.'
                }
            }
        },
        substring: {
            label: 'Substring',
            hint: 'The function returns the part of the text string <code>text</code> from position <code>start</code> in length <code>length</code> characters.',
            param: {
                text: {
                    label: 'text',
                    hint: 'The source text.'
                },
                start: {
                    label: 'start',
                    hint: 'The position of the first character returned.'
                },
                length: {
                    label: 'length',
                    hint: 'The number of characters returned.'
                }
            }
        },
        left: {
            label: 'Left',
            hint: 'The function returns a text string of length <code>length</code> characters from the start of <code>text</code>.',
            param: {
                text: {
                    label: 'text',
                    hint: 'The source text.'
                },
                length: {
                    label: 'length',
                    hint: 'The number of characters returned.'
                }
            }
        },
        right: {
            label: 'Right',
            hint: 'The function returns a text string of length <code>length</code> characters from the end of <code>text</code>.',
            param: {
                text: {
                    label: 'text',
                    hint: 'The source text.'
                },
                length: {
                    label: 'length',
                    hint: 'The number of characters returned.'
                }
            }
        },
        toLower: {
            label: 'To lower case',
            hint: 'The function returns the text string <code>text</code> converted to lowercase.',
            param: {
                text: {
                    label: 'text',
                    hint: 'The source text.'
                }
            }
        },
        toUpper: {
            label: 'To upper case',
            hint: 'The function returns the text string <code>text</code> converted to uppercase.',
            param: {
                text: {
                    label: 'text',
                    hint: 'The source text.'
                }
            }
        },
        round: {
            label: 'Round',
            hint: 'The function rounds the decimal number <code>value</code> to the nearest numeric value with no decimal component. The mid-point between two integers is rounded away from zero, i.e. 0.5 is rounded to 1 and ‑0.5 is rounded to -1.',
            param: {
                value: {
                    label: 'value',
                    hint: 'The value to round.'
                }
            }
        },
        ceiling: {
            label: 'Round up',
            hint: 'The function rounds the decimal number <code>value</code> up to the nearest numeric value with no decimal component.',
            param: {
                value: {
                    label: 'value',
                    hint: 'The value to round.'
                }
            }
        },
        floor: {
            label: 'Round down',
            hint: 'The function rounds the decimal number <code>value</code> down to the nearest numeric value with no decimal component.',
            param: {
                value: {
                    label: 'value',
                    hint: 'The value to round.'
                }
            }
        },
        not: {
            label: 'NOT',
            hint: 'The function returns TRUE if <code>expr</code> is FALSE. Otherwise, it returns FALSE.',
            param: {
                expr: {
                    label: 'expr',
                    hint: 'The source expression.'
                }
            }
        },
        and: {
            label: 'AND',
            hint: 'The function returns TRUE if both <code>expr1</code> and <code>expr2</code> are TRUE. Otherwise, it returns FALSE.',
            param: {
                expr1: {
                    label: 'expr1',
                    hint: 'The first source expression.'
                },
                expr2: {
                    label: 'expr2',
                    hint: 'The second source expression.'
                }
            }
        },
        or: {
            label: 'OR',
            hint: 'The function returns TRUE if at least one of the expressions <code>expr1</code> and <code>expr2</code> is equal to the value TRUE. Otherwise, it returns FALSE.',
            param: {
                expr1: {
                    label: 'expr1',
                    hint: 'The first source expression.'
                },
                expr2: {
                    label: 'expr2',
                    hint: 'The second source expression.'
                }
            }
        },
        in: {
            label: 'Is one value of',
            hint: 'The function returns TRUE if the expression <code>expr1</code> is equal to one of <code>value1</code> and <code>value2</code>. Otherwise, it returns FALSE.',
            param: {
                expr: {
                    label: 'expr',
                    hint: 'The source expression.'
                },
                value1: {
                    label: 'value1',
                    hint: 'The first allowed value.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The second allowed value.'
                }
            }
        },
        notIn: {
            label: 'Is not one value of',
            hint: 'The function returns TRUE if the expression <code>expr1</code> is not equal to one of <code>value1</code> and <code>value2</code>. Otherwise, it returns FALSE.',
            param: {
                expr: {
                    label: 'expr',
                    hint: 'The source expression.'
                },
                value1: {
                    label: 'value1',
                    hint: 'The first disallowed value.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The second disallowed value.'
                }
            }
        },
        if: {
            label: 'If',
            hint: 'The function returns <code>value1</code> if <code>expr</code> is TRUE. Otherwise, it returns <code>value2</code>.',
            param: {
                expr: {
                    label: 'expr',
                    hint: 'The source expression.'
                },
                value1: {
                    label: 'value1',
                    hint: 'The value returned if <code>expression</code> is TRUE.'
                },
                value2: {
                    label: 'value2',
                    hint: 'The value returned if <code>expression</code> is not TRUE.'
                }
            }
        }
    }
};
